<template>
    <aside class="aside-menu" style="overflow: scroll !important;">

        <div class="p-2 border-bottom d-flex flex-row align-items-center justify-content-between">
            <div class="cursor-pointer" @click.prevent="openNotificationsPage">Notifications</div>

            <div v-if="notifications.length" class="bg-dark rounded-circle px-1 cursor-pointer">
                <div class="dropdown" style="z-index: 1020 !important;">
                    <i id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="fas fa-ellipsis-h"></i>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                        <button @click.prevent="markAllAsRead" class="dropdown-item" type="button">Mark all as read</button>
                        <button @click.prevent="removeAllNotifications" class="dropdown-item" type="button">Delete all</button>
                    </div>
                </div>
            </div>
        </div>

        <div @mouseenter="hovered = notification" @mouseleave="hovered = ''" v-if="notifications.length" v-for="notification in notifications" class="p-2 mb-1 text-dark notification d-flex flex-row align-items-center">

            <div @click.prevent="markAsRead(notification, true)" class="d-flex flex-column flex-grow-1 flex-wrap" :class="[notification.data.link ? 'cursor-pointer' : '', notification.read_at ? 'opacity-50' : 'cursor-pointer opacity-100']" style="width: 90%;">
                <div>
                    <i v-if="notification.data.link" class="fas fa-external-link-alt mr-1"></i>
                    {{ notification.data.message }}
                </div>
                <div :class="[ notification.read_at ? '' : 'font-weight-bold orange-color' ]" class="d-flex font-xs">{{ notification.created }} </div>
            </div>

            <div v-show="hovered.id === notification.id" class="bg-dark rounded-circle px-1 cursor-pointer position-absolute" style="margin-left: 75%;">
                <div class="dropdown" style="z-index: 1020 !important;">
                    <i id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="fas fa-ellipsis-h"></i>
                    <div class="dropdown-menu mt-2" aria-labelledby="dropdownMenu2">
                        <button @click.prevent="markAsRead(notification, false)" v-if="!notification.read_at" class="dropdown-item" type="button">Read</button>
                        <button @click.prevent="markAsUnread(notification)" v-if="notification.read_at" class="dropdown-item" type="button">Unread</button>
                        <button @click.prevent="removeNotification(notification)" class="dropdown-item" type="button">Remove</button>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-center" style="width: 10%; height:100%;">
                <span v-if="!notification.read_at" id="dot"></span>
            </div>
        </div>

        <div v-if="notifications.length === 0" class="p-2 text-dark overflow-auto notification">
            <a class="text-dark">
                <div class="d-inline-block" style="width: 10%; height:100%; vertical-align: middle;"></div>
                <div class="d-inline-block align-middle float-right" style="width: 90%;">
                    <span class="font-italic">There are no notifications</span>
                </div>
            </a>
        </div>

    </aside>
</template>

<script>
import api from '../../api/notifications/notifications'

export default {
    name: "NotificationsModal",
    data: () => ({
        hovered: '',
        notifications: [],
    }),
    methods: {
        async fetchData() {
            await api.getUserNotifications()
                .then(res => {
                    this.notifications = res.data
                })
        },
        async markAsRead(notification, redirect = false) {
            await api.notificationMarkAsRead({
                id: notification.id
            })
            .then(res => {
                this.fetchData()
                if (notification.data.link && redirect) {
                    window.open(
                        location.href = notification.data.link,
                        '_blank'
                    );

                }
            })
        },
        async markAllAsRead() {
            await api.allNotificationsMarkAsRead()
            .then(res => {
                this.fetchData()
            })
        },
        async markAsUnread(notification) {
            await api.notificationMarkAsUnread({
                id: notification.id
            })
            .then(res => {
                this.fetchData()
            })
        },
        async removeNotification(notification) {
            await api.notificationRemove({
                id: notification.id
            })
            .then(res => {
                this.fetchData()
            })
        },
        async removeAllNotifications() {
            await api.allNotificationsRemove()
            .then(res => {
                this.fetchData()
            })
        },
        openNotificationsPage() {
            window.open(location.href = '/account/notifications')
        }
    },
    created() {
        this.fetchData()
    },
    watch: {
        '$store.getters.getUserId' : function (val) {
            if (val) {
                window.Echo.private('notifications-' + this.$store.getters.getUserId)
                    .listen('Frontend\\Notification\\NewNotification', (e) => {
                        this.fetchData()
                    })
                    .listen('Frontend\\Notification\\NotificationUpdated', (e) => {
                        this.fetchData()
                    })
            }
        }
    },
    mounted() {

    }
}
</script>

<style scoped>

.opacity-50 {
    opacity: 0.5 !important;
}
.opacity-100 {
    opacity: 1 !important;
}

</style>